module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_m_albino.afc21904.png";